function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 737,
  height: 62,
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("rect", {
  x: 552,
  y: 19,
  width: 185,
  height: 37,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m88.2,55.7c-13.5,0-18.4-9.4-18.4-21.6,0-6.5,1.5-14,6.9-18.2,3.8-3.1,9.1-3.8,13.9-3.8h18.9v7.9h-18c-9.1,0-11.5,4.9-11.5,13.3,0,3.1.6,7.9,2,10.5,2,3.6,6,4.1,9.8,4.1h8.4v-10.4h-12.2v-7.7h21.3v25.8h-21.1v.1Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m130.3,56.2c-10.5,0-16.7-6-16.7-16.7,0-10,7-16.1,16.8-16.1,10.5,0,17,6.2,17,16.8-.2,10.3-7.3,16-17.1,16Zm.1-26c-6.3,0-7.9,4.3-7.9,10s2.1,9.4,8,9.4,7.7-4.5,7.7-9.7c.1-5.4-1.9-9.7-7.8-9.7Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m160,12.2h-8.7v43.5h8.7V12.2Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m182,55.7c-3.2,0-5.8,0-8.7-1.4-6-2.8-8.4-8.4-8.4-14.7,0-3.9.8-7.3,3.4-10.4,3.1-3.9,7-5.2,11.9-5.2h8.3v-11.8h8.7v43.5h-15.2Zm6.4-25h-6.4c-5.5,0-8.3,3.8-8.3,9s2.7,9.3,8.3,9.3h6.3v-18.3h.1Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m218.5,55.7c-4.1,0-7.3-.4-10.7-3.1-4.2-3.2-5.8-8-5.8-13.2,0-4.9,2-10.4,6.3-13.3,2.8-2,6.3-2.2,9.5-2.2h12.3v6.7h-11.6c-4.5,0-6.3,1.1-6.7,5.8h18.4v6.6h-18.4c.3,4.9,3.2,5.8,7.7,5.8h10.7v6.7h-11.8v.2h.1Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256.5,55.7v-20.5c0-3.2-1.3-4.5-4.5-4.5h-7.6v25h-8.8v-31.7h17.5c8.4,0,12.2,3.8,12.2,12.4v19.5h-8.8v-.2Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m298.1,55.8v-18.1h-16.8v18.1h-9.3V12.2h9.3v17.8h16.8V12.2h9.3v43.6h-9.3Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m325.1,55.7c-2.4,0-4.8,0-7-.6-3.9-1-6.2-4.9-6.2-8.8,0-3.1,1.3-6.3,3.8-8.1,2.4-1.7,6.6-1.8,9.3-1.8h10.7v-.6c0-4.6-2.7-5.2-6.6-5.2h-14.7v-6.6h18.4c5.3.1,9.4,2,11.1,7.4.6,2.1.8,4.3.7,6.5v17.8h-19.5Zm10.6-12.5h-11.5c-1.8,0-3.2,1-3.2,3,0,2.8,2.5,2.8,4.8,2.8h10.1v-5.8h-.2Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m367.2,38.3c0-4.8.1-7.6-5.6-7.6h-2.5v25h-8.7v-31.7h12.9c3.5,0,7.2,0,9.8,2.5,2.5,2.2,2.7,5.8,2.7,8.8v3.1h-8.6v-.1h0Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m398.8,55.8h-9.4l-12.8-31.8h9.5l8.1,21.9,8.8-21.9h9.4l-13.6,31.8Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m428.6,55.7c-4.1,0-7.3-.4-10.7-3.1-4.2-3.2-5.8-8-5.8-13.2,0-4.9,2-10.4,6.3-13.3,2.8-2,6.3-2.2,9.5-2.2h12.4v6.7h-11.8c-4.5,0-6.3,1.1-6.7,5.8h18.4v6.6h-18.4c.3,4.9,3.2,5.8,7.7,5.8h10.7v6.7h-11.6v.2Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m468.3,55.4c-1.8.3-3.8.4-5.6.4h-18.1v-6.7h18.4c2-.1,3.5-.4,3.5-2.7,0-3.4-2.8-3.1-5.3-3.1-3.1,0-8,.4-11.1-.7-3.9-1.4-5.9-5.2-5.9-9.3,0-2.2.7-4.5,2.1-6.2,2.4-2.9,5-3.1,8.6-3.1h18.7v6.7h-16.9c-2,0-3.6.1-3.6,2.8,0,3.2,3.4,3.1,5.6,3.1h5.2c5.9,0,10.9,2.5,10.9,9.1.1,4.1-2.3,8.7-6.5,9.7Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m492.8,55.7h0c-4.4,0-8.1-1.1-9.7-5.6-.7-2.1-.8-4.2-.8-6.4v-13.1h-5.6v-6.6h5.6v-11.8h8.7v11.8h8.1v6.7h-8.1v11.5c0,1.4-.1,3.9.7,5,1.5,2.1,5.2,1.5,7.4,1.5v6.7",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.2,32c1-5.3,2-10.7,4.1-15.6,1.4-3.2,3.1-6.4,5.2-9.3C11.4,7.6-.5,20.1.1,35.2c.3,7.6,3.5,14.6,9.3,19.6l3.4-6.2c2.3-4.8,3.3-10.9,4.4-16.6Z",
  fill: "#cb5c28"
}), /*#__PURE__*/React.createElement("path", {
  d: "m46.6,16.3c-3.9,24-16.3,32.4-28.9,38.2l-5.9,2.7c12.5,8.4,29.5,5,37.9-7.4,7.2-10.7,5.9-24.8-3-34.1.1,0,.1.3-.1.6Z",
  fill: "#0065a3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m50.8.3c-13.3,1-20.5,4.9-26,17.7-2,4.5-2.8,9.7-3.8,14.7-1,6.1-2.1,12.3-5,17.8,11.6-5.2,22.7-12.6,26.4-34.9,1.2-5.9,4.1-11.3,8.4-15.3Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m506.6,22.4c-3,0-5.5-2.4-5.5-5.5,0-2.9,2.4-5.5,5.5-5.5,2.9,0,5.5,2.4,5.5,5.5s-2.4,5.5-5.5,5.5Zm0-10.2c-2.7,0-4.8,2.1-4.8,4.8s2.1,4.8,4.8,4.8,4.8-2.1,4.8-4.8c-.1-2.6-2.2-4.8-4.8-4.8Zm1.4,7.6c0-.3-.1-.6-.1-.8-.1-1.1-.6-1.4-1.5-1.4h-1v2.1h-1.4v-5.7h2.7c1.1,0,2.4.3,2.4,1.5.1.7-.3,1.4-1.1,1.7,1.3.4.7,1.4,1.1,2.4l-1.1.2Zm-1-4.7h-1.7v1.5h1.7c.6,0,.8-.1.8-.8s-.3-.7-.8-.7Z",
  fill: "#231f20"
})), /*#__PURE__*/React.createElement("path", {
  d: "m532.5,0v62",
  fill: "none",
  stroke: "#9ea2a2"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m609,19l-4.3,9.4h-29.2v17.5h18v-4.5h-5.4l-7.3-8.3h28.2v15.7l-6,6.5-38.3.3-5.8-7.2v-20h3.2l-9.2-9.4s56.1,0,56.1,0Z",
  fill: "#f84f14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m618,28.5v26.9h17.2v-13.9h15.7v13.8h17.2V19.1h-17.2v14.1h-15.7v-14.1h-23.2l9.1,9.4h-3.1Z",
  fill: "#f84f14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m730.7,19l-12.9,18.1,12.9,18.1h-18.2l-8.7-13.8h-4l-7.8,13.8h-18.2l12-18.1-8.6-8.8h3.1l-9.1-9.4h20.8l7.9,14.2h4l8.7-14.2h18.1v.1Z",
  fill: "#f84f14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m732.9,19.7v2.5h-.7v-2.5h-.5v-.7h1.8v.7h-.6Z",
  fill: "#f84f14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m734.4,20.4v1.8h-.7v-3.2h.8l.4,1.1h0l.4-1.1h.8v3.2h-.6v-1.8h0l-.2.7h-.6l-.3-.7Z",
  fill: "#f84f14"
})))));

function SvgGhGhxLogosOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 737 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhGhxLogosOrange);
export default __webpack_public_path__ + "static/media/GH-GHX-Logos-Orange.79e58a42.svg";
export { ForwardRef as ReactComponent };